// hero__video
import Blue from "~/core";

new Blue({
	name: 'Video',
	selector: "main",
	setup(main) {
		const triggers = [...main.querySelectorAll('.video')];
		const modal = document.createElement("div");
		const overlay = document.createElement("div");
		const container = document.createElement("div");

		modal.classList.add("modal");
		overlay.classList.add("modal__overlay");
		container.classList.add("modal__container");

		overlay.insertAdjacentElement("afterbegin", container);
		modal.insertAdjacentElement("afterbegin", overlay);

		const openModal = (video) => {
			let content = document.createElement("div");
			content.className = 'modal-dialog';
			content.innerHTML = `
				<div class="modal-dialog__close modal-close">
<!--					<i class="glyph-close"></i>-->
				</div>
				<div class="modal-dialog__content">
					<div class="modal-dialog__video">
						<iframe class="modal-dialog__embedded"
								data-page="1"
								src=${video}
	                            frameborder="0" 
								seamless
								allowfullscreen></iframe>
					</div>
				</div>
			`;

			content.addEventListener("click", (e) => e.stopPropagation()); // prevent click on content from closing modal
			container.insertAdjacentElement("afterbegin", content);
			document.body.insertAdjacentElement("beforeend", modal);

			setTimeout(() => {
				const close = document.querySelector('.modal-close');
				close.addEventListener("click", closeModal);
				modal.classList.add("is-open");
				this.$scrollLock.lock(modal);
			});
		};

		const closeModal = () => {
			const cleanup = (e) => {
				if (e.propertyName !== "opacity") return;
				modal.removeEventListener("transitionend", cleanup);
				container.innerHTML = "";
				modal.remove();
			};
			modal.addEventListener("transitionend", cleanup);
			modal.classList.remove("is-open");
			this.$scrollLock.unlock(modal);
		};

		//init
		overlay.addEventListener("click", closeModal);
		triggers.forEach((trigger) => {
			const video = trigger.dataset.url
			trigger.addEventListener("click", () => openModal(video));
		});
	}
});
